import { compare as compareObject } from '../utils/functions';

const buildBotsList = (bots) => {
  const sortedBots = bots.sort((a, b) => compareObject(a, b, 'order'));

  const engines = sortedBots.filter((b) => b.engineRelease.fixedPosition === -1);
  const enginesFixeds = sortedBots.filter((b) => b.engineRelease.fixedPosition > -1);

  enginesFixeds.forEach((element) => {
    const { fixedPosition } = element.engineRelease;
    const isMandatory = element.engineRelease.mandatory === true;
    const component = {
      ...element,
      notAllowedDelete: isMandatory,
      notAllowedChangeLocation: true,
    };
    if (fixedPosition >= engines.length) {
      engines.push(component);
    } else {
      engines.splice(fixedPosition, 0, component);
    }
  });

  engines.forEach((element, idx) => {
    if ((element.engineRelease.fixedPosition > -1
      && idx > 0
      && idx + 1 > element.engineRelease.fixedPosition)
    ) {
      engines[idx - 1].notAllowedEngineAfter = true;
    }
    if (element.engineRelease.fixedPosition > engines.length) {
      engines[idx].notAllowedEngineAfter = true;
    }
  });

  return engines;
};

export default class FlowDTO {
  constructor(flow, chatbot) {
    this.environment = chatbot.environments.find((e) => e.type.mnemonic === 'd');
    this.updateBots(flow.bots);
    return {
      ...flow,
      ...this,
    };
  }

  updateBots(bots) {
    this.bots = buildBotsList(bots);
  }
}
